import type { StatusBadgeColor } from "@/components/Atoms/StatusBadge/StatusBadge.types";
import type { GetOrdersStatus } from "@/api/schemas/getOrdersStatus";
import { formatPersianDate } from "@/lib/format/persian";

function formatOrderDate(value?: string): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return formatPersianDate(date);
}

export type OrderStatusDisplay = {
  color: StatusBadgeColor;
  labelKey: string;
};

export const orderStatusDisplayMap: Record<GetOrdersStatus, OrderStatusDisplay> = {
  created: { color: "warning", labelKey: "orders.status.created" },
  confirmed: { color: "info", labelKey: "orders.status.confirmed" },
  preparing: { color: "neutral", labelKey: "orders.status.preparing" },
  shipped: { color: "info", labelKey: "orders.status.shipped" },
  completed: { color: "success", labelKey: "orders.status.completed" },
  canceled: { color: "neutral", labelKey: "orders.status.canceled" },
};

export function getOrderDisplayFields(order: {
  product_name?: string;
  customer_name?: string;
  customer_city?: string;
  created_at?: string;
  createdAt?: string;
  customer?: { full_name?: string; city?: string };
  items?: { product_name?: string }[];
}) {
  return {
    productName: order.product_name ?? order.items?.[0]?.product_name ?? "—",
    customerName: order.customer_name ?? order.customer?.full_name ?? "—",
    city: order.customer_city ?? order.customer?.city ?? "—",
    date: formatOrderDate(order.created_at ?? order.createdAt),
  };
}
